import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import styled from 'styled-components';

import CitySelector from 'static_pages/components/CitySelector';
import Container from 'system/components/Container';

function Hero({ title, subtitle, cityFromSlug }) {
  return (
    <>
      <MainWrapper>
        <HeroContent>
          <Container size="sm">
            <Typography variant="h2">{title}</Typography>
          </Container>
          <Container size="xs">
            <Typography variant="subtitle2" mt={4} mb={4}>
              {subtitle}
            </Typography>
          </Container>
          <Box
            pl={2}
            pr={2}
            width="100%"
            display="flex"
            maxWidth={600}
            justifyContent="center"
          >
            <CitySelector
              cityFromSlug={cityFromSlug}
              buttonLabelKey="common:labels.findCatering"
            />
          </Box>
        </HeroContent>
      </MainWrapper>
    </>
  );
}

const MainWrapper = styled.div`
  background: ${(props) => props.theme.colors.heroGradient};
  padding: ${(props) => props.theme.spacing(10, 0, 10)};
  position: relative;
  overflow: hidden;

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: ${(props) => props.theme.spacing(6, 0, 6)};
  }
`;

const HeroContent = styled.header`
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export default Hero;
